export default __webpack_public_path__ + "static/media/homeAscent.62916b01.jpg";